import { Card, Divider, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { Fragment } from "react";

import { TbTestChecklist } from "./components/Checklist";
import {
  TB_TEST_TYPE_DETAIL_DESCRIPTIONS,
  TB_TEST_TYPE_LABELS,
  TB_TEST_TYPE_OPTIONS,
} from "./constants";

export function TbTestGuidedUploadInstructions() {
  return (
    <>
      <Stack spacing={3}>
        <Text bold variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
          Your document should include
        </Text>

        <TbTestChecklist />
      </Stack>

      <Stack spacing={3}>
        <Text bold variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
          You may satisfy with one of these tests
        </Text>

        <Card variant="tertiary">
          <CardContent>
            <Stack spacing={4}>
              {TB_TEST_TYPE_OPTIONS.map((testType, index) => (
                <Fragment key={testType}>
                  {index > 0 && <Divider />}
                  <Stack spacing={1}>
                    <Text bold variant="body2">
                      {TB_TEST_TYPE_LABELS[testType]}
                    </Text>
                    <Text variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
                      {TB_TEST_TYPE_DETAIL_DESCRIPTIONS[testType]}
                    </Text>
                  </Stack>
                </Fragment>
              ))}
            </Stack>
          </CardContent>
        </Card>

        <Text variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
          Test requirements and validity may vary by workplace.
        </Text>
      </Stack>
    </>
  );
}
